<section
  [ngStyle]="{
    'min-height': '450px',
    padding: '64px 32px 40px 32px',
    'max-width': '720px',
  }"
  class="u-textAlign-center u-margin-center"
>
  <h4 i18n="@@notFoundView.title" class="u-paddingTop-16 u-marginBottom-8">
    Something went wrong.
  </h4>
  <div i18n="@@notFoundView.subtitle" class="color-grey-300 text-subtitle-1">
    We can't find the page you are looking for.
  </div>
  <app-not-found-dog class="u-display-block"></app-not-found-dog>
  <div class="u-marginBottom-40">
    <a
      i18n="@@global.goHome"
      [routerLink]="['/']"
      mat-raised-button
      color="primary"
    >
      Go home
    </a>
  </div>
  <div class="u-marginBottom-40">
    <p i18n="@@notFoundView.contactUsPrompt" class="color-grey">
      If you get this error more than once, please let us know at <br />
      <a class="color-blue" href="mailto:help@tenthousandcoffees.com">
        help&#64;tenthousandcoffees.com
      </a>
    </p>
  </div>
</section>
